var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-edit-layout',{attrs:{"title":_vm.title}},[_c('orders-form',{attrs:{"item":_vm.item,"id":_vm.id,"permissions":_vm.permissions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }